<div
  class="side-nav-container"
  data-analytics-nav="shelf-menu"
  [attr.aria-hidden]="!isSideNavOpen">
  <div class="close-button-wrapper">
    <button
      class="close-button focus-link"
      [attr.aria-label]="'nexus.side_nav.aria_labels.close' | translate"
      (click)="emitSideNavClose()">
      <rd-shared-icon
        class="close-icon"
        [iconSymbol]="'icon-close'"
        [iconTheme]="'white'"></rd-shared-icon>
    </button>
  </div>

  <div class="nav-container px-4">
    <ul>
      <li class="flex flex-row items-center justify-center">
        <a
          class="menu-link focus-link"
          [routerLink]="[navlinksService.offers.route]"
          (click)="emitSideNavClose()"
          [class.active]="isActivatedOffersMenuItem()">
          <rd-shared-icon
            class="mr-2.5 h-6 w-6"
            [iconSymbol]="'icon-your-offers'"
            [iconTheme]="'white'"></rd-shared-icon>

          <span>{{ offerText | translate }}</span>
        </a>
      </li>

      <li [class.expanded]="getExpandedStatus('redeem')">
        <button
          class="menu-link menu-button redeem-menu focus-link"
          (click)="toggleMenu('redeem')"
          aria-haspopup="listbox"
          [attr.aria-expanded]="getExpandedStatus('redeem')"
          [class.active]="getExpandedStatus('redeem')">
          <rd-shared-icon
            class="mr-2.5 h-6 w-6"
            iconSymbol="icon-bankwide-rewards-star"
            iconTheme="link"></rd-shared-icon>

          <span
            *ngIf="loyaltyCurrency$ | async as loyaltyCurrency"
            class="flex w-full items-start">
            {{
              'wl.bnz.header.redeem'
                | translate: { loyaltyCurrency: loyaltyCurrency.name }
            }}
          </span>

          <span class="icon">
            <rd-shared-icon
              class="expander-arrow"
              [iconSymbol]="'icon-chevron-down'"
              [iconTheme]="'link'"></rd-shared-icon>
          </span>
        </button>

        <ul class="menu-button-content px-12" aria-haspopup="listbox">
          <li *ngFor="let navLink of navlinksService.redemptions">
            <a
              *ngIf="!isExternalNavLink(navLink)"
              class="menu-link submenu-link focus-link"
              (click)="emitSideNavClose()"
              [routerLink]="[navLink.route]"
              [class.active]="isActivatedChildMenuItem(navLink.route)">
              <rd-shared-icon
                class="mr-2.5 h-6 w-6"
                [iconSymbol]="navLink.iconUrl"
                [iconTheme]="'white'"></rd-shared-icon>

              <span>{{ navLink.translationKey | translate }}</span>
            </a>

            <a
              *ngIf="isExternalNavLink(navLink)"
              class="menu-link submenu-link focus-link"
              (click)="emitSideNavClose()"
              [href]="[navLink.route]"
              [class.active]="isActivatedChildMenuItem(navLink.route)">
              <rd-shared-icon
                class="mr-2.5 h-6 w-6"
                [iconSymbol]="navLink.iconUrl"
                [iconTheme]="'white'"></rd-shared-icon>

              <span>{{ navLink.translationKey | translate }}</span>
            </a>
          </li>
          <li *ngIf="navlinksService.flybuysRedemptionLink$ | async as navLink">
            <a
              class="menu-link submenu-link focus-link"
              (click)="emitSideNavClose()"
              [routerLink]="[navLink.route]"
              [class.active]="isFlybuysLinkActive">
              <rd-shared-icon
                class="mr-2.5 h-6 w-6"
                [iconSymbol]="navLink.iconUrl"
                [iconTheme]="'white'"></rd-shared-icon>

              <span>{{ navLink.translationKey | translate }}</span>
            </a>
          </li>
        </ul>
      </li>

      <li
        *ngIf="isLoggedIn$ | async"
        [class.expanded]="getExpandedStatus('my-account')">
        <button
          class="menu-link menu-button my-account-menu focus-link"
          (click)="toggleMenu('my-account')"
          aria-haspopup="listbox"
          [attr.aria-expanded]="getExpandedStatus('my-account')"
          [class.active]="getExpandedStatus('my-account')">
          <rd-shared-icon
            class="mr-2.5 h-6 w-6"
            [iconSymbol]="'icon-my-account'"
            [iconTheme]="'white'"></rd-shared-icon>

          <span class="flex w-full items-start">
            {{ 'wl.bnz.header.my_account' | translate }}
          </span>

          <span class="icon">
            <rd-shared-icon
              class="expander-arrow"
              [iconSymbol]="'icon-chevron-down'"
              [iconTheme]="'link'"></rd-shared-icon>
          </span>
        </button>

        <ul class="menu-button-content px-12" aria-haspopup="listbox">
          <li *ngFor="let navLink of navlinksService.myAccountMobile$ | async">
            <a
              *ngIf="!isExternalNavLink(navLink)"
              class="menu-link submenu-link focus-link"
              (click)="emitSideNavClose()"
              [routerLink]="[navLink.route]"
              [class.active]="isActivatedChildMenuItem(navLink.route)">
              <rd-shared-icon
                class="mr-2.5 h-6 w-6"
                [iconSymbol]="navLink.iconUrl"
                [iconTheme]="'white'"></rd-shared-icon>

              <span>{{ navLink.translationKey | translate }}</span>
            </a>

            <a
              *ngIf="isExternalNavLink(navLink)"
              class="menu-link submenu-link focus-link"
              (click)="emitSideNavClose()"
              [href]="[navLink.route]"
              target="_blank"
              rel="noopener noreferrer"
              [class.active]="isActivatedChildMenuItem(navLink.route)">
              <rd-shared-icon
                class="mr-2.5 h-6 w-6"
                [iconSymbol]="navLink.iconUrl"
                [iconTheme]="'white'"></rd-shared-icon>

              <span>{{ navLink.translationKey | translate }}</span>
            </a>
          </li>
        </ul>
      </li>

      <li
        *ngFor="let navLink of navlinksService.staticPages"
        class="static-page">
        <a
          *ngIf="!isExternalNavLink(navLink)"
          class="menu-link focus-link"
          [routerLink]="[navLink.route]"
          (click)="emitSideNavClose()"
          [class.active]="isActivatedChildMenuItem(navLink.route)">
          <rd-shared-icon
            class="mr-2.5 h-6 w-6"
            [iconSymbol]="navLink.iconUrl"
            [iconTheme]="'white'"></rd-shared-icon>

          <span>{{ navLink.translationKey | translate }}</span>
        </a>
        <a
          *ngIf="isExternalNavLink(navLink)"
          class="menu-link submenu-link focus-link"
          (click)="emitSideNavClose()"
          [href]="[navLink.route]"
          target="_blank"
          rel="noopener noreferrer"
          [class.active]="isActivatedChildMenuItem(navLink.route)">
          <rd-shared-icon
            class="mr-2.5 h-6 w-6"
            [iconSymbol]="navLink.iconUrl"
            [iconTheme]="'white'"></rd-shared-icon>

          <span>{{ navLink.translationKey | translate }}</span>
        </a>
      </li>

      <!-- Contact us page required authentication. -->
      <li *ngIf="isLoggedIn$ | async" class="static-page">
        <a
          class="menu-link focus-link"
          [routerLink]="['/contact_us']"
          (click)="emitSideNavClose()"
          [class.active]="isActivatedChildMenuItem('/contact_us')">
          <rd-shared-icon
            class="mr-2.5 h-6 w-6"
            [iconSymbol]="'icon-contact-us'"
            [iconTheme]="'white'"></rd-shared-icon>

          <span>{{ 'wl.bnz.header.contact_us' | translate }}</span>
        </a>
      </li>
    </ul>
  </div>

  <div class="user-action-group mt-40 pb-5">
    <ng-container *ngIf="!(isLoggedIn$ | async)">
      <rd-shared-button
        class="user-action login focus-link mb-4"
        [buttonContent]="loginButtonContent"
        [buttonTheme]="'primary'"
        (clickFn)="emitUserAction('login')">
        <ng-template #loginButtonContent>
          <span>{{ 'wl.bnz.header.login' | translate }}</span>
        </ng-template>
      </rd-shared-button>

      <rd-shared-button
        class="user-action focus-link"
        [buttonTheme]="'secondary'"
        [buttonText]="'wl.bnz.header.signup' | translate"
        [redirectURL]="
          'https://www.bnz.co.nz/personal-banking/credit-cards/bnz-advantage'
        "
        [isTargetBlank]="true">
      </rd-shared-button>
    </ng-container>

    <ng-container *ngIf="isLoggedIn$ | async">
      <rd-shared-button
        class="user-action logout focus-link"
        [buttonContent]="logoutButtonContent"
        [buttonTheme]="'primary'"
        (clickFn)="emitUserAction('logout')">
        <ng-template #logoutButtonContent>
          <span>{{ 'wl.bnz.header.logout' | translate }}</span>
        </ng-template>
      </rd-shared-button>
    </ng-container>
  </div>
</div>
